module.exports = __webpack_public_path__ + "static/media/covidNormalPill.2f6d247a.svg";